import { FaFacebookF } from "react-icons/fa";

const Footer: React.FC = () => {

    return (
        <footer className="bg-gray-900 text-gray-300 py-10 mt-auto">
            <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center">
                <p className="text-sm">
                    © {new Date().getFullYear()} MyBot Service. Todos los derechos
                    reservados.
                </p>
                <div className="flex space-x-4 mt-3 md:mt-0">
                    <a
                        href="https://www.facebook.com/profile.php?id=61574901914993"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="p-2 bg-gray-700 rounded-full hover:bg-blue-600 transition"
                    >
                        <FaFacebookF className="text-white" />
                    </a>
                </div>
            </div>
        </footer>
    )
};

export default Footer;